export var LogManagementSubject;
(function (LogManagementSubject) {
    LogManagementSubject["SendYourLogs"] = "send-your-logs";
    LogManagementSubject["NonAdminInlineNotification"] = "not-admin";
})(LogManagementSubject || (LogManagementSubject = {}));
//# sourceMappingURL=log-management.enum.js.map